import React from 'react'
import './Section3.css'

const Section3 = () => {
  return (
    <div className="section1-container" id='NEW'>
        <video  src="https://res.cloudinary.com/facemetaclone/video/upload/v1662240596/production_ID_5102663_r5ovph.mp4" type='video/mp4/' className='bg-video' autoPlay loop muted>
        </video>
    </div>
  )
}

export default Section3